import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const ChannelListServicesContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  position: relative;
  left: ${4 * Screen.widthRatio}px;
  margin-top: ${20 * Screen.widthRatio}px;
  width: ${200 * Screen.widthRatio}px;
`;

export default ChannelListServicesContainer;
